

















import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import { ApexOptions } from 'apexcharts';
import dayjs from 'dayjs';

import { Typography } from '@/components/atoms';
import { IPeriod } from '@/models/period';

@Component({ components: { Typography } })
export default class LineChart extends Vue {
  @Prop({ default: '100%' }) width?: number;
  @Prop({ default: '400' }) height?: number;
  @Prop({ required: true }) data!: object;
  @Prop({ required: true }) period!: IPeriod;

  key = 0;
  options: ApexOptions = {
    xaxis: {
      categories: [],
      type: 'datetime'
    },
    yaxis: {
      labels: {
        formatter: value => (Number.isInteger(value) ? String(value) : '')
      }
    },
    chart: {
      toolbar: {
        show: false
      }
    },
    stroke: {
      curve: 'straight'
    },
    markers: {
      size: 6,
      hover: {
        size: 10
      }
    }
  };
  series = [
    {
      name: 'New Customers',
      data: []
    }
  ];

  @Watch('data')
  getTimestamp() {
    const { start, end } = this.period;

    const toUTC = (date: string) =>
      dayjs(date)
        .utc()
        .toDate();

    const diffInTime = toUTC(start).getTime() - toUTC(end).getTime();
    const goBackDays = Math.abs(diffInTime / (1000 * 3600 * 24));

    const daysSorted = [toUTC(end).toDateString()];

    for (let i = 1; i < goBackDays; i++) {
      const newDate = toUTC(end);
      newDate.setDate(toUTC(end).getDate() - i);
      daysSorted.push(newDate.toDateString());
    }

    if (this.options.xaxis) {
      this.options.xaxis.categories = daysSorted.reverse();
    }
    this.key++;
  }
}
